<div class="thumbnail-container cursor-pointer" [class.cursor-pointer]="thumbnailClickPath != ''">
  <div class="x-container" (click)="xClick()" *ngIf="!hideX"><span class="icon-close"></span></div>
  <img class="thumbnail" [src]="fullImageUrl" [style.height]="height" [style.width]="width"
    [style.border-radius]="borderRadius" (click)="thumbnailClick()">
</div>